export default {
  date: 'June 6, 2024',
  title: 'Why GETFLOORPLAN is perfect for developers',
  description: '3D, 360 tours, and renders by AI',
  id: 'why-getfloorplan',
  jsx: () => (
    <div class='novelty__text'>
      <p>In the fast-paced real estate market, developers need efficient and cost-effective solutions to stay competitive. Getfloorplan offers just that.</p>
      <b>Speed</b>
      <p>Our advanced AI technology creates detailed floor plans, 3D visualizations, renders, and virtual tours in just 24 hours, allowing developers to bring projects to market faster.</p>
      <b>Cost-Effective</b>
      <p>Traditional 3D visualizations can be expensive, but Getfloorplan’s services start at just $20, making it a budget-friendly option without compromising quality.</p>
      <b>Customization</b>
      <p>We offer a service for creating a unique style. We tailor our visualizations to match the unique style of your projects, ensuring that the final product meets your specific needs and aesthetics.</p>
      <p>With Getfloorplan, developers can streamline their processes, reduce costs, and enhance their marketing materials, making it the ideal choice for modern real estate projects.</p>
      <p>Join the revolution in real estate with Getfloorplan!</p>
    </div>
  ),
  thumb: 'news/20.webp',
  video: 'https://www.youtube.com/embed/eTTleQYWI34?si=HbvXXs0S2Wk2sTlx',
};
